import { render, staticRenderFns } from "./RCA.vue?vue&type=template&id=52935f97&scoped=true"
import script from "./RCA.vue?vue&type=script&lang=js"
export * from "./RCA.vue?vue&type=script&lang=js"
import style0 from "./RCA.vue?vue&type=style&index=0&id=52935f97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52935f97",
  null
  
)

export default component.exports